import React from 'react';
import styled from '@emotion/styled';
import { mediaQueries } from 'components/mediaQueries';
import { Category } from 'data/SingleArticle/types';
import paths from 'constants/paths';
import { Link } from 'components/Link/Link';

type Props = {
  breadcrumbs: Category[];
};

export const Breadcrumbs: React.FC<Props> = ({ breadcrumbs }: Props) => {
  return (
    <>
      <List qty={breadcrumbs.length}>
        <ListItem key={'home'}>
          <Link href={paths.basePath}>Home</Link>
        </ListItem>
        {breadcrumbs[0]?.parentCategory?.name && (
          <ListItem key={breadcrumbs[0].parentCategory.name}>
            <Link href={paths.categoryHome(breadcrumbs[0].parentCategory.slug)}>
              {breadcrumbs[0].parentCategory.name}
            </Link>
          </ListItem>
        )}
        <ListItem key={breadcrumbs[0].categoryName}>
          <Link
            href={paths.categoryPage({
              categoryAssemblySlug: breadcrumbs[0].categoryAssemblySlug,
            })}
          >
            {breadcrumbs[0].categoryName}
          </Link>
        </ListItem>
      </List>
    </>
  );
};

const List = styled.ul<{ qty: number }>`
  display: flex;
  justify-self: start;
  margin: 20px 15px 20px 0;
  ${mediaQueries.tablet} {
    margin-left: 20px;
  }
  ${mediaQueries.desktop} {
    margin-left: 32px;
  }
`;

const ListItem = styled.li`
  font-weight: 600;
  display: none;
  margin-left: 9px;
  position: relative;

  /** Breadcrumb link, is the only one that should be shown in mobile */
  &:last-of-type {
    display: block;

    &:before {
      margin-right: 6px;
    }
  }

  &:first-of-type {
    margin-left: 0;

    &:before {
      display: none;
    }
  }

  &:before {
    content: '<';
    font-size: 14px;
    margin-right: 9px;
    position: relative;
  }

  ${mediaQueries.tablet} {
    display: block;
    &:last-of-type {
      margin-right: 0;
    }

    &:before {
      content: '>';
    }
  }
`;
